import styled, {css} from "styled-components";

const fontSizes = {
    sb: { d: "2rem", t: "1.5rem", m: "1rem" },
    b: { d: "1.2rem", t: "1rem", m: "0.9rem"},
    m: {d: "0.9rem", t: "0.8rem", m: "0.7rem"},
    s: {d: "0.7rem", t: "0.6rem", m: "0.55rem"}
}

const Flex = styled.div`
  display: flex;
  width: ${props => props.width ? props.width : props.fw ? "100%" : "unset"};
  height: ${props => props.height ? props.height : props.fh ? "100%" : "unset"};
  justify-content: ${props => props.justify || "center"};
  align-items: ${props => props.align || "center"};
  flex-wrap: ${props => props.wrap && "wrap"};
  position: relative;
`

const CFlex = styled.div`
  display: flex;
  flex-direction: column;
  width: ${props => props.width ? props.width : props.fw ? "100%" : "unset"};
  height: ${props => props.height ? props.height : props.fh ? "100%" : "unset"};
  justify-content: ${props => props.justify || "center"};
  align-items: ${props => props.align || "center"};
  flex-wrap: ${props => props.wrap && "wrap"};
  position: relative;
`

const DText = styled.div`
  font-size: ${props => props.cFontSize ? props.cFontSize : fontSizes[props.fontSize].d};
  color: ${props => props.color && props.color};
  ${props => props.main && css`
    color: ${props => props.theme.color};
  `};
  ${props => props.primary && css`
    color: ${props => props.theme.primary};
  `};
  direction: ${props => props._type === "number" && "ltr"};
  font-family: ${props => props.type === "number" && "monospace"};
  
  @media screen and (max-width: 1050px){
    font-size: ${props => props.cFontSize ? props.cFontSize : fontSizes[props.fontSize].t};
  }
  
  @media screen and (max-width: 768px) {
    font-size: ${props => props.cFontSize ? props.cFontSize : fontSizes[props.fontSize].m};
  }
`


const Column = styled.div`
  display: flex;
  justify-content: ${props => props.justify || "flex-start"};
  align-items: center;
  width: ${props => props.width && props.width};
  line-height: 2;
`

const Row = styled.div`
  display: flex;
  width: ${props => props.width ? props.width : "100%"};
  padding: 20px;
  cursor: pointer;
  border-radius: 8px;

  &:hover{
    background-color: ${props => !props.header && props.theme.inActive};
  }

  @media screen and (max-width: 768px){
    padding: 20px 8px;
  }

  @media screen and (max-width: 480px){
    flex-direction: column;
  }
`


const Tab = styled.div`
    cursor: pointer;
    min-width: 80px;
    border-bottom: 1px solid ${props => props.active ? props.theme.mainOrange : props.theme.color};
    border-radius: 4px;
    ${props => props.theme.english && css`
      border-right: 1px solid ${props => props.active ? props.theme.mainOrange : props.theme.color};
    `};
    ${props => !props.theme.english && css`
      border-left: 1px solid ${props => props.active ? props.theme.mainOrange : props.theme.color};
    `};
    padding: 8px 16px;
    color: ${props => props.active ? props.theme.mainOrange : props.theme.color};
    font-size: 1rem;

  @media screen and (max-width: 1050px) {
    font-size: 0.9rem;
  }

  @media screen and (max-width: 768px) {
    font-size: 0.8rem;
  }
`

const Padding = styled.div`
  width: 100%;
  height: 100%;
  flex-direction: inherit;
  display: inherit;
  justify-content: inherit;
  align-items: inherit;
  position: inherit;
  flex-wrap: inherit;
  padding: ${props => props.padding};
`

const RMargin = styled.div`
  width: inherit;
  display: inherit;
  justify-content: inherit;
  align-items: inherit;
  position: inherit;
  margin: 0 ${props => props.margin};
`

export {
    Flex,
    Column,
    CFlex,
    Row,
    DText,
    Tab,
    Padding,
    RMargin
}